import React from 'react';
import './CourseBanner.css';
import BannerImage from '../assets/Banner.jpeg';

const CourseBanner = ({ title }) => {
    return (
        <section className="course-banner-section" data-aos="fade-up">
            <div className="container">
                {title && <h2 className="banner-title">{title}</h2>}
                <div className="banner-wrapper glass">
                    <img src={BannerImage} alt="VLSI Physical Design Course Banner" className="banner-img" />
                </div>
            </div>
        </section>
    );
};

export default CourseBanner;
